/* eslint-disable react/prop-types */
import { createContext, useState, useContext } from 'react';

const ProductSheetContext = createContext(undefined);

export function ProductSheetContextProvider({ children, data }) {
  const [ selectedSunneiShoes, setSelectedSunneiShoes ] = useState(() => {
    if (!data?.sunneiInfo) return null;
    return [ data.sunneiInfo.shoeOne, data.sunneiInfo.shoeTwo ];
  });
  // ahora se utiliza solo para sunnei asi que no hace falta hacer todo el baile que se hace en productPurhcaseCol. Pero estaria bien refactorizar para que se haga igual
  const [ selectedSize, setSelectedSize ] = useState();

  return (
    <ProductSheetContext.Provider value={{
      productSheet: data,
      selectedSunneiShoes,
      setSelectedSunneiShoes,
      selectedSize,
      setSelectedSize,
    }}>
      {children}
    </ProductSheetContext.Provider>
  );
}

export function useProductSheet() {
  const context = useContext(ProductSheetContext);
  if (context === undefined) {
    throw new Error('useProductSheet must be used within a ProductSheetContextProvider');
  }
  return context;
}

export function useSunnei() {
  const {
    productSheet, selectedSunneiShoes, setSelectedSunneiShoes, selectedSize, setSelectedSize,
  } = useProductSheet();

  const hasSunneiConfig = productSheet.sunneiInfo && Object.keys(productSheet.sunneiInfo).length > 0;
  const inspirationImages = productSheet.images?.[0];

  const selectedFirstProductSize = productSheet.sunneiInfo?.products?.[selectedSunneiShoes[0]]?.sizes.find((size) => size.value === selectedSize);
  const selectedSecondProductSize = productSheet.sunneiInfo?.products?.[selectedSunneiShoes[1]]?.sizes.find((size) => size.value === selectedSize);

  const firstProductHasStock = !selectedFirstProductSize || (selectedFirstProductSize && selectedFirstProductSize.quantity > 0);
  let secondProductHasStock = !selectedSecondProductSize || (selectedSecondProductSize && selectedSecondProductSize.quantity > 0);
  if (selectedSecondProductSize && selectedSunneiShoes[0] === selectedSunneiShoes[1]) {
    secondProductHasStock = selectedSecondProductSize.quantity > 1;
  }

  return {
    sunneiInfo: productSheet.sunneiInfo,
    inspirationId: productSheet.code,
    hasSunneiConfig,
    selectedSunneiShoes,
    setSelectedSunneiShoes,
    inspirationImages,
    selectedSize,
    setSelectedSize,
    firstProductHasStock,
    secondProductHasStock,
  };
}
